<template>
  <div ref="pdfContent" class="pdf-content">
    <!-- <button @click="generatePdf">Generate PDF</button> -->
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import { mapGetters, mapActions, mapState } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import QRCode from "qrcode";

let APIDomain = new URL(window.location.href);
if(APIDomain.hostname != "localhost"){
  pdfMake.vfs = pdfFonts.pdfMake.vfs
}

export default {
  components: {
    Loader,
    QRCode,
  },
  data() {
    return {
      name: "PrintBox",
      isLoadingData: false,
      projectID: "",
      partNo: 0,
      header: [],
      companyInfo: [],
      tableData: [],
      lengthData: [],
      imageUrl: "",
      imageSrc: "", // Base64 data of the image
      employee_nik: null,
      employee_name: null,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  created() {
    this.employee_nik = this.userData.nik;
    this.employee_name = this.userData.fullname;
    this.imgLogo();
    EventBus.$on("open-qritem", (data, index) => {
      console.log(data);
      this.projectID = data;
      this.partNo = index
      this.loadData();
    });
  },
  beforeDestroy() {
    EventBus.$off("open-qritem");
  },
  methods: {
    totalQty(index) {
      if (index < 0 || index >= this.tableData.length) {
        return 0; // Return 0 if index is out of bounds
      }

      const boxNo = this.header[index].noBox;
      const boxData = this.tableData.find((box) => box.boxNo === boxNo);

      if (!boxData) {
        return 0; // Return 0 if no data found for the box
      }

      return boxData.people.reduce((sum, person) => {
        return (
          sum +
          person.uniforms.reduce((uniformSum, uniform) => {
            return uniformSum + uniform.qty;
          }, 0)
        );
      }, 0);
    },

    setData() {
      this.loadData();
    },
    loadData() {
      this.isLoadingData = true;
      localStorage.removeItem("redirect_url");
      fnPOST(APIPATH_SALESFORCE.getOrderBox, {
        project_id: this.projectID,
        part_no:this.partNo,
        category:'bundle',
        created_by:this.employee_nik,
        created_by_name:this.employee_name
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (!Array.isArray(data)) {
            console.error("Expected data.payload to be an array.");
            return;
          }

          let header = [];
          let companyInfo = [];
          let tableData = [];

          let currentBoxNo = null;
          let currentNik = null;

          data.forEach((val) => {
            if (val.box_no !== currentBoxNo || currentNik !== val.nik) {
              // Update currentBoxNo and currentNik
              currentBoxNo = val.box_no;
              currentNik = val.nik;

              // Add header and company info only once per box_no
              header.push({
                noPo: val.no_po,
                noBox: val.box_no,
                nik: currentNik,
              });

              companyInfo.push({
                name: val.name_customer,
                address: val.address,
                dimension: val.dimension_box,
              });

              // Create and push a new box entry into tableData
              let boxEntry = {
                boxNo: val.box_no,
                people: [],
              };
              tableData.push(boxEntry);
            }

            // Find the last box entry in tableData
            let boxEntry = tableData[tableData.length - 1];

            // Check if the person already exists in the people array
            let person = boxEntry.people.find((p) => p.nik === val.nik);

            if (!person) {
              // If the person does not exist, add a new entry
              person = {
                name: val.name,
                nik: val.nik,
                function: val.division,
                level: val.department,
                uniforms: [],
                total: 0,
              };
              boxEntry.people.push(person);
            }

            // Add the uniform data and update the total
            person.uniforms.push({
              type: val.item,
              size: val.size,
              qty: parseInt(val.qty),
            });

            person.total += parseInt(val.qty);
          });

          // Set the data properties
          this.header = header;
          this.companyInfo = companyInfo;
          this.tableData = tableData;

          this.generatePdf();

          // console.log("Header:", this.header);
          // console.log("Company Info:", this.companyInfo);
          // console.log("Table Data:", this.tableData);
        })
        .catch((err) => {
          this.isLoadingData = false;
          if (err.response.status !== 401) {

          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
    imgLogo() {
      let APIDomain = new URL(window.location.href);
      let APIPort = "8005";
      let protocol = "https://";
      let APIUrl = protocol + APIDomain.hostname + ":" + APIPort;
      if (APIDomain.hostname == "localhost") {
        APIUrl = "https://testapps.bbi-apparel.com:8005";
      }
      this.imageUrl = APIUrl + "/media/bbi-logo.png";
    },

    async generateQRCode(text) {
      try {
        let qrCodeDataUrl = await QRCode.toDataURL(text, {
          errorCorrectionLevel: "H",
        });
        return qrCodeDataUrl;
      } catch (err) {
        console.error("Error generating QR code:", err);
        return "";
      }
    },

    async convertImage(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Error converting image:", error);
        return null;
      }
    },
    async generatePdf() {
      this.imageSrc = await this.convertImage(this.imageUrl);
      let content = [];
      this.isLoadingData = true;
      let loopPage = 1;

      for (let a = 0; a < this.header.length; a++) {
        let qrCodeDataUrl = await this.generateQRCode(
          this.projectID +
            "///" +
            this.header[a].noBox +
            "///" +
            this.header[a].nik
        ); // Replace with actual text

        // Header with logo and NO BOX
        content.push({
          table: {
            widths: ["*", "auto"], // Adjust column widths (auto for QR code)
            body: [
              [
                {
                  text: `${this.header[a].noBox}`, // Box Number
                  style: "boxNumber",
                  alignment: "center",
                },
                {
                  image: qrCodeDataUrl, // QR code image
                  width: 45, // Adjust width as needed
                  alignment: "right", // Align QR code to the right
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 1 : 0; // Top and bottom border
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 1 : 0; // Left and right border
            },
            hLineColor: function (i, node) {
              return "#000000"; // Border color (black)
            },
            vLineColor: function (i, node) {
              return "#000000"; // Border color (black)
            },
          },
          columnGap: 0,
          margin: [0, 0, 0, 0], // Adjust margin (e.g., bottom margin)
        });

        // PO and Nama Cust
        content.push({
          columns: [
            {
              width: "50%",
              stack: [
                {
                  table: {
                    widths: ["auto"], // Adjust the width as needed
                    body: [
                      [
                        {
                          text: `PO: ${this.header[a].noPo}`,
                          style: "companyInfo",
                          margin: [0, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return i === 0 || i === node.table.body.length ? 1 : 0; // Top and bottom border
                    },
                    vLineWidth: function (i, node) {
                      return i === 0 || i === node.table.widths.length ? 1 : 0; // Left and right border
                    },
                  },
                },
                {
                  text: `${this.tableData[a].people[0].name} - (${this.tableData[a].people[0].nik})`,
                  style: "companyInfo2",
                  margin: [0, 2, 0, 5],
                },
              ],
            },
          ],
          margin: [10, -35, 0, 5],
        });

        content.push({
          text: "", // This empty text will act as a spacer
          margin: [0, 0, 0, 10], // Adjust the vertical margins to create the space (20 can be changed to your desired spacing)
        });

        // Text with border using a table
        // content.push({
        //   // Center the content on the page
        //   alignment: "center",
        //   widths: ["*"],
        //   stack: [
        //     {
        //       table: {
        //         widths: ["*"],
        //         body: [
        //           [
        //             {
        //               text: "NAMA PRODUK",
        //               style: "sectionTitle",
        //               margin: [0, 0, 0, 0],
        //             },
        //           ],
        //         ],
        //       },
        //       layout: {
        //         hLineWidth: function (i, node) {
        //           return i === 0 || i === node.table.body.length ? 1 : 0; // Top and bottom border
        //         },
        //         vLineWidth: function (i, node) {
        //           return i === 0 || i === node.table.widths.length ? 1 : 0; // Left and right border
        //         },
        //       },
        //       margin: [0, 0, 0, 0],
        //     },
        //   ],
        //   margin: [0, 5, 0, 1],
        // });

        // Table Header
        // content.push({
        //   table: {
        //     widths: ["*", "*", "*", "*", "*", "*"],
        //     body: [
        //       [
        //         { text: "No.", style: "tableHeader", alignment: "center" },
        //         { text: "Nama", style: "tableHeader", alignment: "center" },
        //         {
        //           text: "Jenis Seragam",
        //           style: "tableHeader2",
        //           alignment: "center",
        //         },
        //         { text: "Size", style: "tableHeader", alignment: "center" },
        //         { text: "Qty", style: "tableHeader", alignment: "center" },
        //         { text: "Total", style: "tableHeader", alignment: "center" },
        //       ],
        //     ],
        //   },
        //   layout: {
        //     hLineWidth: function (i, node) {
        //       return 1; // Add border width for horizontal lines
        //     },
        //     vLineWidth: function (i, node) {
        //       return 1; // Add border width for vertical lines
        //     },
        //     hLineColor: function (i, node) {
        //       return "#000000"; // Border color
        //     },
        //     vLineColor: function (i, node) {
        //       return "#000000"; // Border color
        //     },
        //     paddingLeft: function (i, node) {
        //       return 1; // Padding for left
        //     },
        //     paddingRight: function (i, node) {
        //       return 1; // Padding for right
        //     },
        //     paddingTop: function (i, node) {
        //       return 1; // Padding for top
        //     },
        //     paddingBottom: function (i, node) {
        //       return 1; // Padding for bottom
        //     },
        //   },
        //   margin: [0, 0, 0, 0],
        // });

        // Table Content
        // this.tableData[a].people.forEach((person, index) => {
        //   // Track rows for the person
        //   let rows = [];

        //   person.uniforms.forEach((uniform, uniformIndex) => {
        //     // Create the row object
        //     const row = [
        //       {
        //         text: uniformIndex === 0 ? index + 1 : "",
        //         style: "tableBody",
        //         alignment: "center",
        //         rowSpan: uniformIndex === 0 ? person.uniforms.length : 1,
        //       },
        //       {
        //         text: uniformIndex === 0 ? person.name : "",
        //         style: "tableBody",
        //         alignment: "center",
        //         rowSpan: uniformIndex === 0 ? person.uniforms.length : 1,
        //       },
        //       { text: uniform.type, style: "tableBody", alignment: "center" },
        //       { text: uniform.size, style: "tableBody", alignment: "center" },
        //       { text: uniform.qty, style: "tableBody", alignment: "center" },
        //       {
        //         text: uniformIndex === 0 ? person.total : "",
        //         style: "tableBody",
        //         alignment: "center",
        //         rowSpan: uniformIndex === 0 ? person.uniforms.length : 1,
        //       },
        //     ];

        //     // Push the row into rows array
        //     rows.push(row);
        //   });

        //   // Add all rows to content
        //   content.push({
        //     table: {
        //       widths: ["*", "*", "*", "*", "*", "*"],
        //       body: rows,
        //     },
        //     layout: {
        //       hLineWidth: function (i, node) {
        //         return 1; // Add border width for horizontal lines
        //       },
        //       vLineWidth: function (i, node) {
        //         return 1; // Add border width for vertical lines
        //       },
        //       hLineColor: function (i, node) {
        //         return "#000000"; // Border color
        //       },
        //       vLineColor: function (i, node) {
        //         return "#000000"; // Border color
        //       },
        //       paddingLeft: function (i, node) {
        //         return 1; // Padding for left
        //       },
        //       paddingRight: function (i, node) {
        //         return 1; // Padding for right
        //       },
        //       paddingTop: function (i, node) {
        //         return 0; // Padding for top
        //       },
        //       paddingBottom: function (i, node) {
        //         return 0; // Padding for bottom
        //       },
        //     },
        //   });
        // });

        if (loopPage == 1) {
          loopPage = 0;
          if (a < this.header.length - 1) {
            content.push({ text: "", pageBreak: "after" });
          }
        }
        loopPage++;
      }

      const docDefinition = {
        content: content,
        pageSize: { width: 227, height: 312 }, // Custom page size in points (8 cm x 11 cm)
        pageOrientation: "potrait", // Landscape orientation
        pageMargins: [10, 5, 10, 5],
        styles: {
          boxNumber: {
            fontSize: 7,
            bold: true,
            margin: [145, 17, 0, 0],
          },
          companyInfo: {
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },
          companyInfo2: {
            fontSize: 6,
            margin: [0, 2, 0, 2],
          },
          sectionTitle: {
            fillColor: "#f2f2f2",
            fontSize: 6,
            bold: true,
            alignment: "center",
          },
          tableHeader: {
            fillColor: "#f2f2f2",
            fontSize: 6,
            bold: true,
            margin: [0, 0, 0, 0],
            alignment: "center",
          },
          tableHeader2: {
            fillColor: "#f2f2f2",
            fontSize: 5,
            bold: true,
            margin: [0, 0, 0, 0],
            alignment: "center",
          },
          tableBody: {
            fontSize: 5,
            margin: [0, 2, 0, 2],
            alignment: "center",
          },
        },
      };

      pdfMake.createPdf(docDefinition).open();
      this.isLoadingData = false;
    },
  },
};
</script>

<style scoped>
.pdf-content {
  display: block;
}
.header .title {
  display: flex;
  justify-content: space-between;
}
.company-info span,
.company-info p {
  margin: 0;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid black;
  padding: 5px;
}
th {
  background-color: #f2f2f2;
}
.total {
  text-align: right;
  font-weight: bold;
}
</style>
